/* @flow */
import { ActionTypes } from 'payments/constants/PaymentSourceConstants.js';
import { dispatcher } from 'lib/Dispatcher';
import PaymentSources from 'collections/PaymentSources';
import PaymentSource from 'entities/PaymentSource';

const PaymentSourceActions = {
  create(token: string) {
    return PaymentSource.create(token).then(paymentSource => {
      dispatcher.dispatch({
        type: ActionTypes.CREATE_PAYMENT_SOURCE,
        paymentSource,
      });
    });
  },

  delete(paymentSource: PaymentSource) {
    return paymentSource.delete().then(() => {
      dispatcher.dispatch({
        type: ActionTypes.DELETE_PAYMENT_SOURCE,
        paymentSource,
      });
    });
  },

  load() {
    return PaymentSources.load().then(paymentSources => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_PAYMENT_SOURCES,
        paymentSources,
      });

      return paymentSources;
    });
  },
};

export default PaymentSourceActions;



// WEBPACK FOOTER //
// ./src/payments/actions/PaymentSourceActions.js